import {Alert} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

export const HandoffMessage = ({message}: { message: string }) => {
    return (
        <Alert color="red" variant="light">
            {I18n.get(message)}
        </Alert>
    );
};
